import { Injectable, signal } from '@angular/core';
import { SmartSearchPromptModalComponent } from '../../components/smart-search-prompt-modal/smart-search-prompt-modal.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Prompt } from '../../models/prompt';
import { ApiService } from './api/api.service';
import { firstValueFrom } from 'rxjs';

const PROMPTS_USAGE_KEY = 'smart-search-prompts-usage';

@Injectable({
  providedIn: 'root',
})
export class SmartSearchPromptService {
  prompts = signal<Prompt[]>([]);

  constructor(
    private apiService: ApiService,
    private modalService: NgbModal
  ) {
    firstValueFrom(this.apiService.prompts.retrievePrompts()).then(prompts => {
      this.prompts.set(this.sortPromptsByUsage(prompts));
    });
  }

  savePrompt(prompt: string, title?: string, id?: number): NgbModalRef {
    const modal = this.modalService.open(SmartSearchPromptModalComponent, { centered: true, windowClass: 'modal-auto' });
    const modalComp = modal.componentInstance as SmartSearchPromptModalComponent;
    modalComp.initialPrompt = prompt;
    modalComp.prompt = prompt;
    modalComp.title = title ?? '';
    modalComp.promptId = id;

    return modal;
  }

  addPrompt(prompt: Prompt) {
    this.prompts.set(this.sortPromptsByUsage([...this.prompts(), prompt]));
  }

  modifyPrompt(id: number, title: string, text: string) {
    const prompt = this.prompts().find(prompt => prompt.id === id);
    if (prompt) {
      prompt.title = title;
      prompt.text = text;
    }
  }

  removePrompt(id: number) {
    this.prompts.set(this.prompts().filter(prompt => prompt.id !== id));
  }

  sortPromptsByUsage(prompts: Prompt[]): Prompt[] {
    return [...prompts].sort((a, b) => this.getPromptUsageDate(b) - this.getPromptUsageDate(a));
  }

  savePromptUsage(prompt: Prompt): void {
    const usageDataStr = localStorage.getItem(PROMPTS_USAGE_KEY);
    const usageData: Record<string, number> = usageDataStr ? JSON.parse(usageDataStr) : {};

    const promptKey = prompt.id;
    if (promptKey) {
      usageData[promptKey] = Date.now();
      localStorage.setItem(PROMPTS_USAGE_KEY, JSON.stringify(usageData));
    }
  }

  private getPromptUsageDate(prompt: Prompt): number {
    try {
      const usageDataStr = localStorage.getItem(PROMPTS_USAGE_KEY);
      if (!usageDataStr) {
        return 0;
      }

      const usageData: Record<string, number> = JSON.parse(usageDataStr);
      const promptKey = prompt.id;
      return promptKey ? usageData[promptKey] || 0 : 0;
    } catch (error) {
      return 0;
    }
  }
}
